import * as React from 'react';
import { Cross2Icon } from '@radix-ui/react-icons';
import * as ToastPrimitives from '@radix-ui/react-toast';

import { cn } from 'utils/styles';

import { Callout } from 'components/common/Callout';
import { IconButton } from 'components/common/IconButton';

const ToastProvider = ToastPrimitives.Provider;

const ToastViewport = ({ className, ...props }: React.ComponentPropsWithoutRef<typeof ToastPrimitives.Viewport>) => (
  <ToastPrimitives.Viewport
    className={cn(
      'fixed top-[10%] left-[50%] z-1000 flex max-h-screen w-full -translate-x-1/2 flex-col gap-2 list-none p-0 md:max-w-111.25',
      className,
    )}
    {...props}
  />
);

type ToastComponentProps = Omit<
  React.ComponentPropsWithoutRef<typeof ToastPrimitives.Root> & React.ComponentPropsWithoutRef<typeof Callout>,
  'children' | 'content'
> & {
  content: React.ReactNode;
};

const Toast = ({ status, content, ...props }: ToastComponentProps) => {
  return (
    <ToastPrimitives.Root
      {...props}
      className="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-20 data-[state=closed]:slide-out-to-top-24 data-[state=open]:slide-in-from-bottom-10 w-full rounded-lg bg-(--white) dark:bg-(--black)"
    >
      <Callout
        status={status}
        customCloseButton={
          <ToastPrimitives.Close asChild>
            <IconButton type="button" size="1" variant="ghost" toast-close="" className={cn('text-neutral-12! mt-0!')}>
              <Cross2Icon />
            </IconButton>
          </ToastPrimitives.Close>
        }
      >
        {content}
      </Callout>
    </ToastPrimitives.Root>
  );
};

type ToastProps = React.ComponentPropsWithoutRef<typeof Toast>;

export { type ToastProps, ToastProvider, ToastViewport, Toast };
